<template>
    <div class="login_container">
    <!-- <div class="account_row">
          <div class="account_title">
         Welcome to Consultancy Finder. Please Login.
          </div>
      </div> -->
        
    <form class="form_box login_form_box">
        <div class="form_img">
            <img src="@/assets/cmst_logo.png" alt="CMST" class="form_logo_img">
        </div>
        <div class="account_row">
          <div class="account_title">
         Welcome to Consultancy Finder. Please Login.
          </div>
      </div>
        <div class="form-group">
          <label>Email Address</label>
          <input v-model=loginData.email v-validate="'required|email'" type="email" class="form-control" name="email" placeholder="Enter your email address">
        <span>{{ errors.first('email') }}</span>
        </div>
        <div class="form-group">
          <label for="pwd">Password</label>
          <input v-model=loginData.password v-validate="'required'" type="password" class="form-control" name="password"  placeholder="Enter Password">
        <span>{{ errors.first('password') }}</span>
        </div>
        <!-- <div class="row_btn"> -->
          <div class="btn_container">
          <button class="btn_submit" @click.prevent=loginAccount>LOGIN</button>
        </div>
        <div class="login_row">
          <span>Don't have an account? Please <a @click="$router.push('/signup')">SIGN UP</a> here</span>
        </div>
        <!-- </div> -->
        
    </form>
    </div>
</template>

<script>
export default {
    data () {
      return {
        loginData: {
          client_id: 0,
        }
        }
    },
    methods: {
      loginAccount(){
        this.$validator.validate().then(async result => {
          if(result){
          await this.$store.dispatch('loginApplicant',this.loginData)
          } 
        });
      }
    },
    mounted(){
      document.title = 'Login - Consultancy Finder';  
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue